<template>
    <div class="plane-ticket" v-if="isApp && !isTekApp && planeInfo && baseInfo.classBrandParentId === 22">
        <div class="title" v-if="planeInfo.specialPriceUrl">
            <div class="title-item">
                特价机票<a @click="goPlaneDiscount" href="javascript:;">找特价<span><i class="arrow"></i></span></a>
            </div>
        </div>
        <div class="content" v-if="planeInfo.planTicketInfo" @click="goDiscount">
            <span class="content-item1"></span>
            <span>{{planeInfo.planTicketInfo.departCityName}}</span>
            <span class="content-item2"></span>
            <span>{{planeInfo.planTicketInfo.destinationCityName}}</span>        	
            <span class="price"><i>¥</i><em>{{planeInfo.planTicketInfo.price}}</em>起</span>
        </div>
    </div>
</template>

<script>
import { eventTrack } from '@/business/analy';
import { mapState } from 'vuex';

export default {
    name: 'planeTicket',
    data() {
        return {
        }
    },
    props: {
        isApp: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        isTekApp: {
            type: Boolean,
            default: function () {
                return false
            }
        },
        baseInfo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    computed: {
        ...mapState({
            planeInfo: state => state.detail && state.detail.planeInfo
        })
    },
    created () {
        if (typeof window !== 'undefined') {
            this.$store.dispatch('detail/queryPlaneInfo',{ destCityCode: this.baseInfo.destinationCode });
        }
    },
    methods: {
        goDiscount(){
        	window.location.href = this.planeInfo && this.planeInfo.planTicketInfo.planTicketUrl;
        	eventTrack('CLICK_INDEX_PLANELIST');
        },
        goPlaneDiscount(){
        	window.location.href = this.planeInfo && this.planeInfo.specialPriceUrl;
        	eventTrack('CLICK_INDEX_MOREPLANE');
        },
        eventTrack
    }
}
</script>

<style lang="scss">
@import '../style/common.scss';
.plane-ticket {
    margin: 9px 0;
    padding: 0 13px;
    .title {
        position: relative;
        height: 40px;
        font-size: 18px;
        line-height: 40px;
        color: $fontStrongColor;
	    &-item {
		    a {
			    position: absolute;
                right: 0;
                top: 6px;
                height: 24px;
                padding-right: 20px;
                line-height: 24px;
                font-size: 14px;
                color: $fontColor;
                & > span {
                    position: absolute;
                    right: 0;
                    width: 24px;
                    height: 24px;
                    display: inline-block;
                    overflow: hidden;
                }
	        }
	        .arrow {
		        display: block;
                width: 24px;
                height: 24px;
                transform: scale(0.6);
                transform-origin: center;
                overflow: hidden;
		        &:before,
		        &:after {
		            content: " ";
		            position: absolute;
		            left: 50%;
		            top: 50%;
		            width: 50%;
		            height: 2px;
		            margin: -1px 0 0 -25%;
		            background: #c2c6cc;
		        }
		
		        &:before {
		            transform: translate(0, -4px) rotate(45deg);
		        }
		
		        &:after {
		            transform: translate(0, 4px) rotate(-45deg);
		        }
		    }		     
	    }
    }
    .content {
        position:relative;
        padding: 21px 0 2px;
        height:40px;
        border-radius:9px;
        background-color: #fff;
        &:before {
            content: "";
            position: absolute;
            left: 0%;
            top: 50%;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            background: #f0f0f0;
            z-index: 1;
            transform: translateX(-50%) translateY(-50%);
        }
        &:after {
            content: "";
            position: absolute;
            right: 0%;
            top: 50%;
            width: 12px;
            height: 12px;
            border-radius: 100%;
            background: #f0f0f0;
            z-index: 1;
            transform: translateX(50%) translateY(-50%);
        }
    	span{
    		height:20px;
    		display:inline-block;
            font-size: 16px;
            font-weight: 700;
            vertical-align: middle;
    	}
    	&-item1{      
    		width: 35px;    		
            background: url('../../assets/airplane.png') no-repeat center;
            background-size: 21px;
    	    margin-left: 12px;
    	    margin-right: 5px;
    	}
    	&-item2{ 
            width: 35px;       
            background: url('../../assets/right-arrow.png') no-repeat center;
            background-size: contain;
            margin: 0 5px; 	
    	}
        .price {
            position: relative;
            top: 1px;
            float:right;
            margin-right: 20px;
            font-size:12px;
            color:rgba(32,48,64,0.75);
            font-weight: 300;
            i {
                font-weight: 500;
                font-style: normal;
                color:#f9743a;
            }
            em {
                font-weight: 500;
                font-family: "DINCondensed-Bold";
                font-size: 20px;
                color:#ff6436;
                margin: 0 2px 0 1px;
                letter-spacing: 1px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// PlaneTicket.vue